
namespace RioERP.Wallet {

    @Serenity.Decorators.registerClass()
    export class CreditWalletDialog extends Serenity.EntityDialog<CreditWalletRow, any> {
        protected getFormKey() { return CreditWalletForm.formKey; }
        protected getIdProperty() { return CreditWalletRow.idProperty; }
        protected getLocalTextPrefix() { return CreditWalletRow.localTextPrefix; }
        protected getNameProperty() { return CreditWalletRow.nameProperty; }
        protected getService() { return CreditWalletService.baseUrl; }
        protected getDeletePermission() { return CreditWalletRow.deletePermission; }
        protected getInsertPermission() { return CreditWalletRow.insertPermission; }
        protected getUpdatePermission() { return CreditWalletRow.updatePermission; }

        protected form = new CreditWalletForm(this.idPrefix);

    }
}